import { render } from "./ColorGalleryCard.vue?vue&type=template&id=3a125e42"
import script from "./ColorGalleryCard.vue?vue&type=script&lang=js"
export * from "./ColorGalleryCard.vue?vue&type=script&lang=js"

import "./ColorGalleryCard.vue?vue&type=style&index=0&id=3a125e42&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__